import { Controller } from "@hotwired/stimulus"

export default class CapInputController extends Controller {
  static targets = ["select", "numberField", "numberInput", "hiddenField", "typeField"]

  declare selectTarget: HTMLSelectElement
  declare numberFieldTarget: HTMLElement
  declare numberInputTarget: HTMLInputElement
  declare hiddenFieldTarget: HTMLInputElement
  declare typeFieldTarget: HTMLInputElement

  connect() {
    this.selectType()
  }

  selectType() {
    const selected = this.selectTarget.value

    this.numberFieldTarget.style.display = selected === "limited" ? "" : "none"

    if (selected !== "limited") {
      this.numberInputTarget.value = ""
    }

    this.syncHiddenField()
  }

  syncHiddenField() {
    const type = this.selectTarget.value

    this.typeFieldTarget.value = type

    if (type === "unlimited") {
      this.hiddenFieldTarget.value = ""
    } else if (type === "blocked") {
      this.hiddenFieldTarget.value = "0"
    } else {
      this.hiddenFieldTarget.value = this.numberInputTarget.value
    }
  }
}
